import React from "react";
import clsx from "clsx";
import makeStyles from "@mui/styles/makeStyles";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    position: "relative",
    zIndex: 1031,
  },

  transparent: {
    position: "absolute",
    zIndex: 1000,
    height: "auto",
  },
}));

const PanelLoadingIndicator = ({
  color = "primary",
  size = 40,
  transparent = false,
  className,
}) => {
  const classes = useStyles();

  return (
    <Container
      id="panel-loading"
      classes={{
        root: clsx(classes.root, {
          [classes.transparent]: transparent,
        }),
      }}
      className={className}
    >
      <CircularProgress color={color} size={size} />
    </Container>
  );
};

export default PanelLoadingIndicator;
